import { EmeraldIcon } from "@emerald-react/icon";
import { useEffect, useRef, useState } from "react";

interface SortDropdownProps {
  onSortOptionChange: (value: string) => void;
}

const SortDropdown = ({ onSortOptionChange }: SortDropdownProps) => {
  const [open, setOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Team Data order");
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handleOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open]);

  const sortOptions = [
    { value: "Team Data order", label: "Team Data order" },
    { value: "A to Z", label: "A to Z" },
    { value: "Z to A", label: "Z to A" },
  ];

  const onClickHandler = (value: string) => {
    onSortOptionChange(value);
    setSelectedOption(value);
    setOpen(false);
  };

  return (
    <div ref={ref}>
      <button onClick={() => setOpen((v) => !v)} className="">
        <EmeraldIcon icon="sort_by_alpha" type="filled" variant="icon" />
      </button>

      {open && (
        <ul className="absolute bg-white rounded-md shadow-elevation-12 mt-2 py-2 z-10 text-sm">
          {sortOptions.map((option) => (
            <li
              key={option.label}
              onClick={() => onClickHandler(option.value)}
              className={`p-2 ${selectedOption === option.label ? "selected" : ""} cursor-pointer flex items-center`}
            >
              {selectedOption === option.label && (
                <EmeraldIcon
                  icon="check"
                  type="filled"
                  variant="icon"
                  className="mr-2 text-primary-500"
                />
              )}
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SortDropdown;
